import React from 'react';
import Card from '../../../muiComponents/Card';
import { LinearProgress } from '@mui/material';
import useTranslate from '../../../customHooks/useTranslate';

interface CardsStructureProps<T> {
    onScroll: (e: React.UIEvent<HTMLDivElement, UIEvent>) => void;
    items: T[];
    cardComponent: React.FC<{ item: T }>;
    isLoading: boolean;
}

const CardsStructure = <T,>({
    onScroll,
    items,
    isLoading,
    cardComponent: CardComponent,
}: CardsStructureProps<T>) => {
    const translate = useTranslate();

    return (
        <div className='flex-column flex-grow min-height-0'>
            <div
                className=' flex-grow flex-column gap-20 min-height-0 overflow-y-auto overflow-x-hidden'
                onScroll={onScroll}
            >
                {items.map((item, index) => (
                    <CardComponent key={index} item={item} />
                ))}
                {items.length === 0 && (
                    <Card className='padding20 flex-column gap-20'>
                        <caption className='no-results'>
                            {isLoading && <LinearProgress />}
                            {items.length === 0 &&
                                !isLoading &&
                                translate('no_results')}
                        </caption>
                    </Card>
                )}
            </div>
        </div>
    );
};

export default CardsStructure;
